import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import MainLayout from "../../../../Layouts/Main";
import { useDispatch, useSelector } from "react-redux";
import { getPastAssessment_USER, } from "../../../../Redux/Slices/User/userSlice";
import PastAssessmentCard from "Components/PastAssessmentCard";
import moment from "moment";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Recommendations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);

  const [userName, setUserName] = useState("");
  const [pastAssessmentData, setpastAssessmentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const getAllPastAssessmentUser = (data) => {
    setpastAssessmentData(data.data.data_list);
    setUserName(data?.userName);
  }

  useEffect(() => {
    const getPastAssessmentUsers = (page) => {
      dispatch(
        getPastAssessment_USER({
          page: page,
          callBack: getAllPastAssessmentUser,
        })
      );
    };
    getPastAssessmentUsers(currentPage);
  }, [dispatch, currentPage]);

  const handleViewRecommendation = (id) => {
    navigate(`/recommendations/recommendation/${id}`);
  };


  return (
    <MainLayout>
      <div className="recommendations">
        {/* Header Section */}
        <div className="header">
          <h1 className="left-title">Recommendations</h1>
        </div>
        <div>
          {/* <h1 className="pending-assessment-subheading">Past Assessment Recommendations</h1> */}
          {isLoading === "loading"
            ? // Skeleton loader for past assessments while loading
            Array(3)
              .fill()
              .map((_, index) => (
                <div key={index} className="skeleton-container">
                  <Skeleton height={180} style={{ marginBottom: "20px" }} />
                </div>
              ))
            : pastAssessmentData?.map((item) => {
              return (
                <PastAssessmentCard
                  key={item.assignment_id}
                  data={item}
                  assessmentName={item?.assessment_name}
                  assessmentSubmittedDate={item?.submitted_at ? moment(item?.submitted_at).tz("Asia/Kolkata").format(
                    "DD-MM-YYYY"
                  ) : "-"}
                  referenceName={item?.assessment_backlog?.reference_name}
                  assessorName={item.assessment_backlog?.users?.assessor_name}
                  handleViewRecommendation={() =>
                    handleViewRecommendation(item.backlog_id)
                  }
                  userName={userName}
                  showViewReport={false}
                  showViewRecommendations={true}
                  approvalStatus={item.assessment_backlog?.approval_status}
                />
              );
            })}
        </div>

      </div>
    </MainLayout>
  );
};

export default Recommendations;
